import { withStyles } from '../../../utils';
import styles from './InteracWordmark.module.scss';

const cn = withStyles(styles);

export type ErrorTextProps = {
  type?: 'eTransfer' | 'moneyRequest' | 'bulkPayout';
};

export default function InteracWordmark({ type = 'eTransfer' }: ErrorTextProps) {
  return (
    <div className={cn('interacText')}>
      <i>Interac e-Transfer</i>
      <sup>®</sup>
      {type === 'moneyRequest' && 'Request Money'}
      {type === 'bulkPayout' && 'Bulk Payout'}
    </div>
  );
}
